
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/social-media-marketing/proposals/smm-custom-proposal",
      function () {
        return require("private-next-pages/social-media-marketing/proposals/smm-custom-proposal.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/social-media-marketing/proposals/smm-custom-proposal"])
      });
    }
  